// extracted by mini-css-extract-plugin
module.exports =  {"root":"UqPvqrxBmvs5FyVQOcCa","formWrapperWithLabels":"vLTCHCC7O6Bbxsz1T07B","labelAlwaysOn":"wIB7dmwwUlnIQAO1cXQl"};